import * as cartActions from 'store/cart/actions';
import * as serviceBookingsActions from 'store/serviceBookings/actions';
import * as serviceRegistrationActions from 'store/serviceRegistration/actions';

import { concatMap, filter, map, withLatestFrom } from 'rxjs/operators';
import { showErrorNotification, showGenericErrorNotification } from './actions';

import { ERROR_PATH } from 'shared/consts';
import { Epic } from 'redux-observable';
import { RootAction } from 'store/actions';
import { RootState } from 'store/reducer';
import { isActionOf } from 'typesafe-actions';
import { of } from 'rxjs';
import { replace } from 'connected-react-router';
import { toSerializableError } from 'store/utils/map-generic-error.util';

// Covers both /checkout and /quick-checkout routes
const isCheckoutRouteOpen = (state: RootState): boolean => !!state.router?.location?.pathname?.includes('checkout');

export const handleFailedRequests: Epic<RootAction, RootAction, RootState> = (action$, state$) =>
  action$.pipe(
    // Add failure actions to trigger error modal here and in the test file
    filter(
      isActionOf([
        serviceRegistrationActions.registerUser.failure,
        cartActions.createCart.failure,
        cartActions.submitCart.failure,
        serviceBookingsActions.patchServiceBookingStatus.failure,
      ]),
    ),
    withLatestFrom(state$),
    // The checkout/quick-checkout modals already surface submit failures
    // inline (error label next to the payment method), so don't stack the
    // page-level booking error modal on top of them. Submit failures outside
    // the payment modal (e.g. free-event auto-submit) still need it.
    filter(([action, state]) => !(isActionOf(cartActions.submitCart.failure)(action) && isCheckoutRouteOpen(state))),
    map(([action]) => {
      const error = toSerializableError('error' in action.payload ? action.payload.error : action.payload);

      return showErrorNotification({
        action: action.type,
        error,
        errorCode: error.response?.statusCode?.toString(),
      });
    }),
  );

export const handleGenericErrors: Epic<RootAction, RootAction, RootState> = action$ =>
  action$.pipe(
    filter(isActionOf([showGenericErrorNotification])),
    concatMap(() => of(replace(ERROR_PATH))),
  );
